import { createElement } from 'react';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import type { RouteObject } from 'react-router';

import { getAdminRouteModule } from '@treneo/features/admin';
import { getAuthRouteModule } from '@treneo/features/auth';
import { getCoursesRouteModule } from '@treneo/features/courses';
import {
  getOrganizationsRouteModule,
  getTrainerInvitePublicRoutes,
  OrganizationInvitationsPage,
  OrganizationUsersPage
} from '@treneo/features/organizations';
import { urls } from '@treneo/shared/constants';
import { ForbiddenPage, NotFoundPage } from '@treneo/shared/ui';

import { AdminLayoutRoute, NotRequireAuth, RequireAuth } from '../router/layouts';

const getSharedRoutes = (): RouteObject[] => [
  { path: urls.forbiddenPage, element: createElement(ForbiddenPage) },
  { path: urls.notFoundPage, element: createElement(NotFoundPage) },
  { path: '*', element: createElement(NotFoundPage) }
];

const getAdminLayoutChildren = (): RouteObject[] => {
  const adminRoutes = getAdminRouteModule().routes;
  const organizationsModule = getOrganizationsRouteModule();
  return [
    ...adminRoutes.slice(0, 2),
    ...organizationsModule.routes,
    ...adminRoutes.slice(2),
    {
      path: urls.organizationUsersPage(':organizationId'),
      element: createElement(OrganizationUsersPage)
    },
    {
      path: urls.organizationInvitationsPage(':organizationId'),
      element: createElement(OrganizationInvitationsPage)
    }
  ];
};

export const getComposedRoutes = (): RouteObject[] => {
  const authModule = getAuthRouteModule();
  const coursesModule = getCoursesRouteModule();

  return [
    ...authModule.routes,
    ...getTrainerInvitePublicRoutes(),
    {
      element: createElement(RequireAuth),
      children: [
        ...coursesModule.routes,
        {
          element: createElement(AdminLayoutRoute),
          children: getAdminLayoutChildren()
        }
      ]
    },
    {
      element: createElement(NotRequireAuth),
      children: [
        { path: '/linkedin', element: createElement(LinkedInCallback) },
        ...getSharedRoutes()
      ]
    }
  ];
};
